// Self-contained related-products loader (no dependency on Dawn's global.js).
// Finds [data-lum-related], fetches the recommendations section for the current product
// (same URL that works directly, with intent=related), and injects the returned markup.
// After injecting, dispatches events so the slider (Swiper) initializes on the new content.
(function () {
    'use strict';

    function initRelated(el) {
        if (!el || el.dataset.lumRelatedDone) return;
        el.dataset.lumRelatedDone = '1';

        var url = el.getAttribute('data-url');
        if (!url) return;

        fetch(url)
            .then(function (r) {
                if (!r.ok) throw new Error('bad response ' + r.status);
                return r.text();
            })
            .then(function (text) {
                // Response is the rendered section HTML. Parse and inject its body content.
                var doc = new DOMParser().parseFromString(text, 'text/html');
                var html = doc.body ? doc.body.innerHTML : text;

                if (html && html.trim().length) {
                    el.innerHTML = html;
                    // let slider initializers pick up the new .lum-pswiper, and nudge layout
                    document.dispatchEvent(new CustomEvent('lum:sliders:init'));
                    window.dispatchEvent(new Event('resize'));
                }
            })
            .catch(function () { /* silent: show nothing on failure */ });
    }

    function boot() {
        document.querySelectorAll('[data-lum-related]').forEach(initRelated);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();